import axios from 'axios';
import { API_URL } from './apiConfig';
import authService from './authService';

const axiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    console.log('Request:', config.url, config);
    const token = authService.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    console.log('Response:', response.config.url, response);
    return response;
  },
  (error) => {
    console.error('Response error:', error.config?.url, error);
    // Check if error is due to token expiration
    const isTokenExpired = 
      (error.response?.status === 401) && 
      (error.response?.data?.message === 'jwt expired' || 
       error.response?.data?.error === 'jwt expired' ||
       error.response?.data?.message === 'Invalid token' ||
       (typeof error.response?.data === 'string' && error.response.data.includes('expired')) ||
       error.message.includes('jwt expired'));

    // Handle token expiration or unauthorized access
    if (isTokenExpired) {
      console.log('Token expired, logging out...');
      authService.logout();
      // Show notification to user
      alert('Your session has expired. Please log in again.');
      window.location.href = '/login';
      return Promise.reject(new Error('Session expired'));
    } else if (error.response?.status === 401) {
      // Other authorization errors
      authService.logout();
      window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance; 